import { render, staticRenderFns } from "./GridLinkPriorityCombined.vue?vue&type=template&id=d9873f68&"
import script from "./GridLinkPriorityCombined.ts?vue&type=script&lang=js&"
export * from "./GridLinkPriorityCombined.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports